import React from 'react';
import './WhatWeDoSection.css';

const WhatWeDoSection = ({ config }) => {
  return (
    <div className="what-we-do-section">
      <div className="what-we-do-content">
        <h2 className="what-we-do-title">{config.title}</h2>
        <div className="services-grid">
          {config.services.map((service, index) => (
            <div key={index} className="service-item">
              <div className="service-icon">
                <img 
                  src={service.icon} 
                  alt={service.label}
                  className="icon-img"
                />
              </div>
              <span className="service-label">{service.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatWeDoSection;
